module.exports = __webpack_public_path__ + "img/description4.bbb3753d.svg";